import { render, staticRenderFns } from "./BlogpostCarousel.vue?vue&type=template&id=4ef79dc6&scoped=true&"
import script from "./BlogpostCarousel.vue?vue&type=script&lang=js&"
export * from "./BlogpostCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BlogpostCarousel.vue?vue&type=style&index=0&id=4ef79dc6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef79dc6",
  null
  
)

component.options.__file = "BlogpostCarousel.vue"
export default component.exports